import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _get from "lodash/get";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
// TODO: nets is unmaintained. Move to something else.
// https://nerdwallet.atlassian.net/browse/FEI-2443
import nets from 'nets';
import datadog from '@nerdwallet/datadog';
import { getCoreHTTPHeaders } from './headers';

/**
 * Encode a params object to URL query string parameters.
 *
 * In the future, this code may not need to exist anymore. For instance, Axios
 * will encode query params on our behalf. Or, we could switch to using
 * `new URLSearchParams(...).toString()`. Note that these will encode things
 * differently than they have been historically, e.g. a space will be encoded
 * as `+` instead of `%20`. Our backends should be tolerant of this, but it is
 * a risk that should be evaluated before changing this behavior.
 *
 * @see https://stackoverflow.com/questions/59889140/different-output-from-encodeuricomponent-vs-urlsearchparams
 * @see https://github.com/axios/axios/blob/d99d5faac29899eba68ce671e6b3cbc9832e9ad8/lib/helpers/buildURL.js#L5
 */
export function encodeQueryParams(params) {
  return Object.entries(params).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  }).join('&');
} // TODO: there must be a better way to do this. I fear that using the Buffer
// global here will cause webpack or Babel to include a Buffer polyfill.
//
// TODO: the best opportunity to revamp or remove this function will probably
// be when we decide to replace `nets` with something else.
// https://nerdwallet.atlassian.net/browse/FEI-2443

function didFailToParse(body) {
  // In the case of node.js it leaves the data object as a utf8 encoded Buffer object.
  if (typeof Buffer !== 'undefined') {
    return body instanceof Buffer || typeof body === 'string';
  } // In the case of the browser, the request module will leave the body as a string.
  // (assuming the config.json option is set)


  return typeof body === 'string';
}

function getNWA() {
  if (typeof window !== 'undefined') {
    return window.nwa;
  }

  return undefined;
}
/**
 * Wrap `nets` so that it returns a Promise.
 */


function netsPromisified(configNets, config) {
  return new Promise(function (resolve, reject) {
    configNets(config, function (err, response, body) {
      if (err) {
        // Attach response and body to the err so caller can see the response
        // eslint-disable-next-line no-param-reassign
        err.response = response; // eslint-disable-next-line no-param-reassign

        err.body = body;
        reject(err);
      } else {
        resolve({
          response: response,
          body: body
        });
      }
    });
  });
}
/**
 * Creates a new `HttpClient` instance, which can be used to make calls to
 * nwapi services with the correct headers, etc.
 */


function createNewHttpClient(config) {
  // Timeout is specified in milliseconds.
  var DEFAULT_TIMEOUT = 5000;
  var configNets = config.nets,
      nwa = config.nwa,
      xhrTimeout = config.xhrTimeout;
  var kountSessionID;
  var referringClientID;

  function setKountSessionID(id) {
    kountSessionID = id;
  }

  function setReferringClientID(id) {
    referringClientID = id;
  }

  function setUserLoggedIn() {
    if (nwa) {
      nwa.setUserProp('gaUserAuthenticationState', 'logged_in');
    }
  }

  function setUserLoggedOut() {
    if (nwa) {
      nwa.setUserProp('gaUserAuthenticationState', 'logged_out');
    }
  }

  function fetch(_x) {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(args) {
      var body, canonicalPath, followRedirect, method, serverRequest, url, json, headers, cookies, params, timeout, queryParams, netsConfig, context, coreHeaders, _yield, response, responseBody, parseError;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              body = args.body, canonicalPath = args.canonicalPath, followRedirect = args.followRedirect, method = args.method, serverRequest = args.serverRequest, url = args.url;
              json = args.json;
              headers = args.headers || {};
              cookies = args.cookies || {};
              params = args.params || {};
              timeout = args.timeout || xhrTimeout || DEFAULT_TIMEOUT;
              queryParams = encodeQueryParams(params); // Only tack on question mark if query params are present

              queryParams = queryParams ? "?".concat(queryParams) : ''; // For GET/HEAD requests, use `json: true`, which instructs
              // nets/requests/xhr to expect a JSON response but does not send a request
              // body. For other requests, set `json: {}`, which will also default to a
              // empty object as the request body. This is because nw_api requires a
              // valid json request body even if there are no inputs. Ideally SDKs would
              // should explicitly pass in {} as input when this is needed, but too many
              // existing SDKs rely on the behavior here.

              if (typeof body === 'undefined' && typeof json === 'undefined') {
                if (method === 'GET' || method === 'HEAD') {
                  json = true;
                } else {
                  json = {};
                }
              } // Basic request config.


              netsConfig = {
                method: method,
                url: url + queryParams,
                followRedirect: followRedirect,
                timeout: timeout,
                withCredentials: true,
                body: body
              };

              if (typeof json !== 'undefined') {
                netsConfig.json = json;
              }

              context = {
                url: url,
                config: config,
                serverRequest: serverRequest,
                cookies: cookies,
                referringClientID: referringClientID,
                kountSessionID: kountSessionID
              }; // Get all headers, including cookies

              _context.next = 14;
              return getCoreHTTPHeaders(context);

            case 14:
              coreHeaders = _context.sent;
              netsConfig.headers = _objectSpread(_objectSpread({}, headers), coreHeaders);
              _context.next = 18;
              return !canonicalPath ? netsPromisified(configNets, netsConfig) : datadog.instrumented('node.outgoing_requests.http', {
                tags: {
                  caller_client_id: config.clientID,
                  domain: url.replace(/^https?:\/\//, '').split('/')[0],
                  endpoint: canonicalPath.replace(/^https?:\/\//, ''),
                  method: method
                }
              }, function () {
                return netsPromisified(configNets, netsConfig);
              });

            case 18:
              _yield = _context.sent;
              response = _yield.response;
              responseBody = _yield.body;

              // 401 sometimes implies that a user is unauthenticated and we need to update our tracking accordingly
              // TODO: Revisit when we have error codes (PIE-1108)
              if (response && response.statusCode === 401 && _get(responseBody, 'error.data.user_is_logged_out')) {
                setUserLoggedOut();
              } // The underlying 'request' (github.com/request/request) node module will attempt to
              // JSON.parse the response body, but won't do anything if it fails to parse.
              // If the response contains a Content-Type header of application/json, but request failed to
              // parse the result into an object, then we can assume that this is unexpected and should
              // therefore reject with an error
              // Lee: added a check to ignore HTTP 204: No content as... it's no content.


              if (!(response && response.headers['content-type'] === 'application/json' && response.statusCode !== 204 && didFailToParse(responseBody))) {
                _context.next = 27;
                break;
              }

              parseError = new Error('Failed to JSON.parse body'); // TODO: separate type?

              parseError.response = response;
              parseError.body = responseBody;
              throw parseError;

            case 27:
              return _context.abrupt("return", {
                response: response,
                body: responseBody
              });

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetch.apply(this, arguments);
  }

  return {
    fetch: fetch,
    setKountSessionID: setKountSessionID,
    setReferringClientID: setReferringClientID,
    setUserLoggedIn: setUserLoggedIn,
    setUserLoggedOut: setUserLoggedOut
  };
}

export function createHttpClient(config) {
  if (!config || _typeof(config) !== 'object') {
    throw new Error('config is required');
  }

  return createNewHttpClient(_objectSpread({
    nets: nets,
    nwa: getNWA()
  }, config));
}